import React from "react";

import type {
    TwoUpNavigationCardBlock,
    TwoUpNavigationBlock as Value,
} from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { Themed } from "../../styles/themes";
import { RichTextStreamBlock } from "../RichTextStreamBlock";
import { SpacerBlock } from "../SpacerBlock";
import { TwoUpNavigationCard } from "./TwoUpNavigationCard";

import styles from "./index.module.scss";

const TwoUpNavigationCardGrid = ({
    value,
}: {
    value: TwoUpNavigationCardBlock[];
}) => (
    <div className={styles.grid}>
        {value.map((card, index) => (
            <TwoUpNavigationCard key={index} value={card} />
        ))}
    </div>
);

const components = {
    rich_text_stream: RichTextStreamBlock,
    spacer: SpacerBlock,
    cards: TwoUpNavigationCardGrid,
};

export const TwoUpNavigationBlock = ({ value }: { value: Value }) => {
    if (!value.items) return <></>;

    return (
        <Themed theme={value.theme} tag="section">
            <StreamField
                tagName={React.Fragment}
                components={components}
                value={value.items}
            />
        </Themed>
    );
};
